export const tableStyles = {
  table: {
    width: '100%',
    borderCollapse: 'collapse',
  },
  th: {
    textAlign: 'left',
    fontSize: '14px',
    color: '#777',
    padding: '8px 0',
    borderBottom: '1px solid #eee',
  },
  td: {
    fontSize: '14px',
    padding: '12px 0',
    verticalAlign: 'top',
  },
  title: {
    fontWeight: '600',
  },
  subtitle: {
    fontSize: '13px',
    color: '#888',
  },
};

export const baseStyles = {
  card: {
    border: '1px solid #e0e0e0',
    borderRadius: '12px',
    padding: '24px',
    maxWidth: '600px',
    margin: '0 auto 40px',
    backgroundColor: '#fff',
  },
  sectionTitle: {
    fontSize: '18px',
    fontWeight: '600',
    marginBottom: '16px',
  },
};
